import React, { useState } from "react";
import { PlusOutlined, DeleteOutlined, DownOutlined, RightOutlined } from "@ant-design/icons";
import { Button, Input, Space, Card } from "antd";

const NestedArrayComponent = ({ value = [], onChange, placeholder, disabled }) => {
  const [expandedItems, setExpandedItems] = useState({});

  const toggleExpand = (path) => {
    setExpandedItems(prev => ({ ...prev, [path]: !prev[path] }));
  };

  const addSubAccount = (parentPath = "") => {
    const newSubAccount = {
      _id: "",
      name: "",
      balance: 0,
      code: "",
      description: "",
      subAccounts: [],
    };

    if (parentPath === "") {
      onChange([...value, newSubAccount]);
    } else {
      const updateNested = (items, path) => {
        const [current, ...rest] = path.split(".");
        
        return items.map((item, idx) => {
          if (idx.toString() === current) {
            if (rest.length === 0) {
              return {
                ...item,
                subAccounts: [...(item.subAccounts || []), newSubAccount],
              };
            } else {
              return {
                ...item,
                subAccounts: updateNested(item.subAccounts || [], rest.join(".")),
              };
            }
          }
          return item;
        });
      };
      
      onChange(updateNested(value, parentPath));
    }
  };

  const removeSubAccount = (parentPath, index) => {
    if (parentPath === "") {
      const newValue = [...value];
      newValue.splice(index, 1);
      onChange(newValue);
    } else {
      const updateNested = (items, path) => {
        const [current, ...rest] = path.split(".");
        
        return items.map((item, idx) => {
          if (idx.toString() === current) {
            if (rest.length === 0) {
              const newSubAccounts = [...(item.subAccounts || [])];
              newSubAccounts.splice(index, 1);
              return { ...item, subAccounts: newSubAccounts };
            } else {
              return {
                ...item,
                subAccounts: updateNested(item.subAccounts || [], rest.join(".")),
              };
            }
          }
          return item;
        });
      };
      
      onChange(updateNested(value, parentPath));
    }
  };

  const updateSubAccount = (parentPath, index, field, fieldValue) => {
    if (parentPath === "") {
      const newValue = [...value];
      newValue[index][field] = fieldValue;
      onChange(newValue);
    } else {
      const updateNested = (items, path) => {
        const [current, ...rest] = path.split(".");
        
        return items.map((item, idx) => {
          if (idx.toString() === current) {
            if (rest.length === 0) {
              const newSubAccounts = [...(item.subAccounts || [])];
              newSubAccounts[index][field] = fieldValue;
              return { ...item, subAccounts: newSubAccounts };
            } else {
              return {
                ...item,
                subAccounts: updateNested(item.subAccounts || [], rest.join(".")),
              };
            }
          }
          return item;
        });
      };
      
      onChange(updateNested(value, parentPath));
    }
  };

const renderSubAccounts = (items, depth = 0, parentPath = "") => {
  return items.map((item, idx) => {
    const currentPath = parentPath ? `${parentPath}.${idx}` : `${idx}`;
    const isExpanded = expandedItems[currentPath];
    const hasChildren = item.subAccounts && item.subAccounts.length > 0;

    return (
      <div
        key={item._id || idx}
        style={{
          marginLeft: depth * 24,
          marginBottom: 10,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            padding: "10px 12px",
            borderRadius: 10,
            background: "#ffffff",
            border: "1px solid #f0f0f0",
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
            transition: "all 0.2s",
          }}
        >
          {hasChildren ? (
            <Button
              type="text"
              size="small"
              icon={isExpanded ? <DownOutlined /> : <RightOutlined />}
              onClick={() => toggleExpand(currentPath)}
            />
          ) : (
            <div style={{ width: 24 }} />
          )}

          <Input
            placeholder="Account name"
            value={item.name}
            onChange={(e) =>
              updateSubAccount(parentPath, idx, "name", e.target.value)
            }
            style={{ width: 150 }}
          />

          <Input
            placeholder="Code"
            value={item.code}
            onChange={(e) =>
              updateSubAccount(parentPath, idx, "code", e.target.value)
            }
            style={{ width: 80 }}
          />

          <Input
            type="number"
            placeholder="Balance"
            value={item.balance}
            onChange={(e) =>
              updateSubAccount(
                parentPath,
                idx,
                "balance",
                parseFloat(e.target.value) || 0
              )
            }
            style={{ width: 80 }}
          />

          <Input
            placeholder="Description"
            value={item.description}
            onChange={(e) =>
              updateSubAccount(parentPath, idx, "description", e.target.value)
            }
            style={{ flex: 1 }}
          />

          <Space>
            <Button
              type="default"
              icon={<PlusOutlined />}
              onClick={() => addSubAccount(currentPath)}
            />

            <Button
              danger
              icon={<DeleteOutlined />}
              onClick={() => removeSubAccount(parentPath, idx)}
            />
          </Space>
        </div>

        {hasChildren && isExpanded && (
          <div style={{ marginTop: 6 }}>
            {renderSubAccounts(item.subAccounts, depth + 1, currentPath)}
          </div>
        )}
      </div>
    );
  });
};

  return (
    <div>
      <Button
  icon={<PlusOutlined />}
  onClick={() => addSubAccount("")}
  style={{
    width: "100%",
    height: 44,
    borderRadius: 10,
    fontWeight: 500,
    marginBottom: 16,
    backgroundColor: "#6254bf",
    borderColor: "#6254bf",
    color: "#fff"
  }}
>
Add Main Sub-Account</Button>
      
      {value && value.length > 0 && (
        <div style={{ maxHeight: 400, overflowY: "auto" }}>
          {renderSubAccounts(value)}
        </div>
      )}
      
      {(!value || value.length === 0) && (
        <div style={{ textAlign: "center", padding: 20, color: "#999" }}>
          No sub-accounts added. Click "Add Main Sub-Account" to start building your hierarchy.
        </div>
      )}
    </div>
  );
};

export default NestedArrayComponent;